import React, { memo, forwardRef } from "react";
const SvgAlphabetY = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.56 20.55c-.186.44-.386.827-.6 1.16-.2.347-.44.633-.72.86-.28.24-.607.42-.98.54-.373.12-.82.18-1.34.18-.506 0-.853-.12-1.04-.36-.187-.24-.28-.48-.28-.72s.074-.453.22-.64a.9.9 0 01.58-.34.928.928 0 01.18-.02h.2c.32 0 .627-.113.92-.34.293-.213.554-.6.78-1.16l.48-1.22-3.62-7.96a2.058 2.058 0 01-.14-.4c-.013-.12-.02-.22-.02-.3 0-.307.114-.567.34-.78.227-.227.514-.34.86-.34.213 0 .427.06.64.18.213.12.4.373.56.76l2.6 6.22h.04l2.24-6.16c.147-.413.327-.68.54-.8.227-.133.44-.2.64-.2.347 0 .627.1.84.3.227.2.34.46.34.78a1.615 1.615 0 01-.14.66l-4.12 10.1z"
      />
    </svg>
  );
});
SvgAlphabetY.displayName = "SvgAlphabetY";
const MemoForwardRef = memo(SvgAlphabetY);
export default MemoForwardRef;
